import type { FreeWorkoutItem } from './freeWorkoutBuilder';
export interface GuidedWorkoutBlock { kind: 'exercise' | 'superset' | 'circuit'; exerciseIndices: number[]; sets: number; restSeconds: number; warmupSets: number }
/** Groups stay contiguous, matching the execution scheduler. A repeated distant id never joins two blocks. */
export function buildGuidedWorkoutBlocks(items: readonly FreeWorkoutItem[]): GuidedWorkoutBlock[] {
  const blocks: GuidedWorkoutBlock[] = [];
  items.forEach((item, index) => {
    const previous = index > 0 ? items[index - 1] : null;
    const groupType = item.groupType ?? 'superset';
    const join = item.groupId && previous?.groupId === item.groupId && (previous.groupType ?? 'superset') === groupType;
    const warmupSets = item.setTypes?.filter(type => type === 'warmup').length ?? 0;
    if (join) {
      const block = blocks[blocks.length - 1];
      block.exerciseIndices.push(index); block.sets = Math.max(block.sets, item.sets);
      block.restSeconds = Math.max(block.restSeconds, item.restSeconds); block.warmupSets += warmupSets;
    } else blocks.push({ kind: item.groupId ? groupType : 'exercise', exerciseIndices: [index],
      sets: item.sets, restSeconds: item.restSeconds, warmupSets });
  });
  return blocks;
}
